export const propName = (obj, type) =>
  Object.keys(obj).find((key) => obj[key] === type);
